import { Modal } from '@carbon/react';
import styles from './delete-modal.module.scss';
interface DeleteModalProps {
  onClose: () => void;
  onDelete: () => void;
  title: string;
  description: string;
  open: boolean;
}

export const DeleteModal = ({
  onClose,
  onDelete,
  title,
  description,
  open,
}: DeleteModalProps) => {
  return (
    <Modal
      open={open}
      size="md"
      modalHeading={title}
      className={styles.deleteModal}
      onRequestClose={onClose}
      onRequestSubmit={onDelete}
      secondaryButtonText="Cancel"
      primaryButtonText="Yes, Delete"
      preventCloseOnClickOutside
      closeButtonLabel="Close"
      aria-label="delete model config"
    >
      <p className={styles.description}>{description}</p>
    </Modal>
  );
};
